import { Component, OnInit, Input, TemplateRef, ViewChild } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { PropertyListingService } from '../../shared/providers/property-listing.service';
import { IPropertyDetails } from '../../shared/models/propertydetails';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { IPropertyCard } from '../../shared/models/propertycard';
import { HomeService } from '../../shared/providers/home.service'; //Remove all the code related to home service once similar properties is received
import { IPropertySearchCriteria } from '../../shared/models/propertysearchcriteria';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { AuthenticationService } from '../../shared/auth/authentication.service';
import { AuthService } from '../../shared/auth/auth.service';
import { IPlaceOfferInputModel } from '../../shared/models/PlaceOfferInputModel';
declare module 'googlemaps';
import { ToastService } from '../../shared/providers/toast.service';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import { CommonService } from '../../shared/providers/common.service';
import { LoaderService } from '../../shared/providers/loader.service';
import { IDocumentAccessInputModel } from '../../shared/models/DocumentAccessInputModel';
import { IDocumentAccessOutputModel } from '../../shared/models/DocumentAccessOutputModel';
import { Lightbox } from 'ngx-lightbox';
import { TabsetComponent } from 'ngx-bootstrap/tabs';
import { environment } from '../../../environments/environment'
import { DataTablesResponse } from '../../shared/models/datatables-response';
import { DataTablesModule, DataTableDirective } from 'angular-datatables';
import { HttpClient } from '@angular/common/http';
import { OpportunityOfferOutputModel } from '../../shared/models/OpportunityOfferOutputModel'
import { PropertyManagementService } from '../../shared/providers/property-management.service';
import { ContactType, DocumentType, DocAccessStatus } from '../../shared/enum/enum';
import { SavePropertyAccessLogModel } from '../../shared/models/SavePropertyAccessLogModel';
import { IMessageInput } from '../../shared/models/MessageInputModel';
import { ValidationService } from '../../shared/providers/validation.service';
import { IAddToFavorites } from '../../shared/models/AddToFavoriteInputModel';
import { BrokerageManagerService } from '../../shared/providers/brokerage-manager.service';
import { collapseColumns } from '../../shared/models/collapseColumns';

export enum PropertyTabs {
  Home = 1,
  Memorandom = 2,
  Diligence = 3,
  Offer = 4,
  Inquiries = 5,
  PlaceOffer = 6,
  OfferDetail = 7,
  SendInquiryPopup = 8,
  Message = 9,
  Share = 10,
  ActivityLog = 11,
  Duplicates = 13,
  Comps = 16,
  Analytics = 15,
}

enum SocialMedia {
  Twitter = 1,
  FB = 2,
  LinkedIn = 3
}

@Component({
  selector: 'app-de-view-property',
  templateUrl: './de-view-property.component.html'
})
export class DeViewPropertyComponent implements OnInit {


  modalRef: BsModalRef;
  property = {} as IPropertyDetails;
  toggleDetailsText = '- Hide Details';
  isDescriptionVisible = true;
  propertyGuid: string = "";
  propertyTabs = PropertyTabs;
  activeTab = this.propertyTabs.Home;
  similarProperties: IPropertyCard[] = [];
  similarPropertiesCount: number;
  searchCriteria = {} as IPropertySearchCriteria;
  isUserLoggedIn = false;
  placeOfferInputModel = {} as IPlaceOfferInputModel;
  savePropertyAccessLogModel = {} as SavePropertyAccessLogModel;
  fileExtensionType = "document";
  fileUploadType: string = "single";
  showFileUpload = true;
  activeBannerTab = 1;
  public accessAdded: number = 0;
  docPreview: any;
  documentPreview: BsModalRef;
  map: google.maps.Map;
  @ViewChild('gmap') gmapElement: any;
  @ViewChild('gmapSatellite') gmapSatelliteElement: any;
  @ViewChild('staticTabs') staticTabs: TabsetComponent;
  propertyLatitude: number = 0;
  propertyLongitude: number = 0;
  contactType = ContactType;
  hasOtherContactType = false;
  user: any;
  loggedInUserId: number = 0;
  canEditProperty = false;
  canEditPropertyForBroker = false;
  videoUrl: SafeResourceUrl = null;
  videoUrlResponse: any;
  dueDiligenceDocList: any[] = [];
  offeringMemorandomDocList: any[] = [];
  docAccessInput = {} as IDocumentAccessInputModel;
  docAccessOutput = {} as IDocumentAccessOutputModel;
  docAccessStatus = DocAccessStatus;
  defaultProfilePic: string;
  ndaDetails = {} as any;
  only1PropImage = false;
  propertyId: number;
  dtOptions = {};
  table: DataTableDirective;
  offers: OpportunityOfferOutputModel[];
  selectedOfferId: number;
  currentIndex: number;
  isPropertyForSale = true;
  visewDocRequestList: boolean = false;
  @ViewChild(DataTableDirective) dtElement: DataTableDirective;

  prevPage = "Property List";
  prevPageRouteLink = "property-listing";
  placeOfferVisibility: boolean = false;
  messageInput = {} as IMessageInput;
  unreadMessageCount: number = 0;
  showContactUs: boolean = true;
  currentUrl: string;
  socialMedia = SocialMedia;
  enableShare: boolean = true;
  viewActivityLog: boolean = false;
  enableMessage: boolean = false;
  canEditHistory: boolean = false;
  selectedColumns = [];
  //defaultTypeText: IMultiSelectTexts = {
  //  defaultTitle: 'Select Columns',
  //};
  defaultTypeSettings = {
    singleSelection: false,
    text: "Select Columns",
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    enableSearchFilter: true,
    classes: "myclass custom-class",
    enableFilterSelectAll: false,
  }
  portfolioProperties: any[] = [];
  TableColumns = [];
  showmap = true;
  characterstics: string = '';
  capratetext: string = 'Cap Rate';

  protected readonly BASE_URL: string = environment.base_url;
  constructor(private _brokerageManagerService: BrokerageManagerService, private _propertyService: PropertyListingService, private _lightbox: Lightbox,
    private activatedRoute: ActivatedRoute,
    private http: HttpClient,
    private router: Router,
    private _homeService: HomeService,
    private modalService: BsModalService,
    public authService: AuthenticationService, private _toastService: ToastService, private _propertyManagerService: PropertyManagementService, private sanitizer: DomSanitizer, public commonService: CommonService, private loaderService: LoaderService,
    private metaTag: Meta, public Validation: ValidationService, private _auth0: AuthService) {
    this.activatedRoute.params.subscribe(params => {

      this.propertyGuid = params.id;
      this.defaultSearchCriteriaValues();
      this.activeTab = this.propertyTabs.Home;
      this.defaultProfilePic = 'assets/img/default-profile-img.png';
      this.authService.isLoggedIn.subscribe(response => {
        let url = this.router.url;
        this.setUserDetails();
        if (url.toString().indexOf("/viewdeproperty") != -1) {
          this.loadPageContent();
        }
      });
    });
  }
  saveOfferingMemorandomToAuditLog() {

    var propertyId = this.property.Id;
    var userId = this.user.Id;
    var constData = {
      UtmId: null,
      UtmSource: null,
      UtmMedium: null,
      UtmCampaign: null,
      UtmTerm: null,
      UtmContent: null,
      Propertyid: propertyId,
      UserId: userId
    };
    this._propertyManagerService.saveOfferingMemorandomToAuditLog(constData).subscribe(response => {
      ////this.bindLeadSummary();            
    });
  }
  saveDueDiligenceToAuditLog() {

    var propertyId = this.property.Id;
    var userId = this.user.Id;
    var constData = {
      UtmId: null,
      UtmSource: null,
      UtmMedium: null,
      UtmCampaign: null,
      UtmTerm: null,
      UtmContent: null,
      Propertyid: propertyId,
      UserId: userId
    };
    this._propertyManagerService.saveDueDiligenceToAuditLog(constData).subscribe(response => {
      ////this.bindLeadSummary();            
    });
  }

  onBreadCrumbClick() {
    //if (this.authService.IsUserRole(this.authService.UserRole.Admin)) {
    //    this.router.navigateByUrl("propertylisting");
    //}
    //else {
    //    this.router.navigateByUrl(this.prevPageRouteLink);
    //}
    this.router.navigateByUrl(this.prevPageRouteLink);
  }

  VerifyProperty(propertyId: number) {
    this._brokerageManagerService.UpdateDataEntryPropertyTimeStamp(propertyId).subscribe(resp => {
      this._toastService.addToast({
        title: 'Success',
        msg: this.property.IsPortfolio ? "Portfolio verified" : "Property verified",
        timeout: 5000,
        theme: 'bootstrap',
        position: 'bottom-right',
        type: 'success'
      });
    });
  }

  mapProp: any;
  private setMap(isSatellite = false) {
    if (!isSatellite) {
      this.mapProp.mapTypeId = google.maps.MapTypeId.ROADMAP;
      this.map = new google.maps.Map(this.gmapElement.nativeElement, this.mapProp);
    }
    else {
      this.mapProp.mapTypeId = google.maps.MapTypeId.SATELLITE;
      this.map = new google.maps.Map(this.gmapSatelliteElement.nativeElement, this.mapProp);
    }

    setTimeout(() => { this.setCenter(); }, 10);
  }

  lightbox_arr = [];
  open(index: number): void {
    this.lightbox_arr = [];
    if (this.only1PropImage) {
      let new_arr = {
        src: this.property.Images[0].FilePath,
        caption: this.property.Images[0].Id
      };
      this.lightbox_arr.push(new_arr);
      // open lightbox
      this._lightbox.open(this.lightbox_arr, 0);
    }
    else {
      this.property.Images.map((item) => {
        let new_arr = {
          src: item.FilePath,
          caption: item.Id
        };
        this.lightbox_arr.push(new_arr);

      });

      // open lightbox
      this._lightbox.open(this.lightbox_arr, index);
    }
  }
  openDeleteModal(template: TemplateRef<any>, classes: any, id: number, index: number) {
    this.selectedOfferId = id;
    this.currentIndex = index;
    this.modalRef = this.modalService.show(template, { class: classes });


  }
  deleteOffers() {
    var loggedinUserId = this.user.Id;
    var offerId = this.selectedOfferId;
    var index = this.currentIndex;
    if (offerId > 0) {
      this._propertyManagerService.deleteOffers(offerId, loggedinUserId).subscribe(response => {
        if (response.toString() == 'true') {
          this.offers.splice(index, 1);
          this._toastService.addToast({
            title: 'Success', msg:
              'Inquiry deleted successfully', timeout:
              5000, theme: 'bootstrap', position: 'bottom-right', type: 'success'
          });
        }
        else {
          this._toastService.addToast({
            title: 'Error', msg:
              'Error deleting inquiry', timeout:
              5000, theme: 'bootstrap', position: 'bottom-right', type: 'error'
          });
        }

      });
    }
  }
  tabToShow = null;
  showLikesAndViews = false;
  routeName = '';
  routeLink = ''
  ngOnInit() {
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      this.routeName = params['prevroute'];
      this.routeLink = params['link'];
      if (this.routeName !== null && this.routeName !== undefined) {
        this.prevPage = this.routeName;
        this.prevPageRouteLink = this.routeLink;
      }
      if (params['property_tab'] !== null && params['property_tab'] !== undefined) {
        this.tabToShow = params['property_tab'];
      }
      else if (params['tab'] !== null && params['tab'] !== undefined) {
        this.tabToShow = params['tab'];
      }
    });

    //(<any>window).Intercom('boot', {
    //    app_id: environment.intercom_api,
    //    hide_default_launcher: false
    //});

    window.scrollTo(0, 0);

  }
  nextTabToShow = this.propertyTabs.Home;
  showPlaceOffer = true;
  setUserDetails() {
    this.authService.isLoggedIn.subscribe(i => { this.isUserLoggedIn = i });
    this.user = this.authService.user != null ? this.authService.user : '';
    if (this.isUserLoggedIn) {
      let loggedUserDetails = (JSON.parse(localStorage.getItem('currentUser')));
      this.user = loggedUserDetails;
      this.loggedInUserId = this.user.Id;
      if (this.authService.DataEntryStaff()) {
        this.canEditProperty = true;
        this.canEditPropertyForBroker = true;
      }
      if (this.authService.Admin() || this.authService.SuperAdmin()) {
        this.canEditProperty = true;
        this.showPlaceOffer = false;
        this.canEditPropertyForBroker = true;
        this.visewDocRequestList = true;
        this.viewActivityLog = true;
      }
      else if (this.authService.Broker()) {
        this.canEditProperty = true;
        this.canEditPropertyForBroker = false;
        this.visewDocRequestList = true;
      }
      if (this.authService.Principal1031() || this.authService.Broker() || this.authService.Admin() || this.authService.SuperAdmin() || this.authService.DataEntryStaff()) {
        this.enableMessage = true;
      }
      this.enableShare = true;

      if (this.authService.IsUserRole(this.authService.UserRole.Principal1031) || this.authService.IsUserRole(this.authService.UserRole.Principal) || this.authService.IsUserRole(this.authService.UserRole.ExternalBroker)) {
        this.showAddToFav = true;
      }

      if (this.authService.ExternalBroker()) {
        this.showPlaceOffer = true;
      }
    }
  }
  slideConfig = {
    "slidesToShow": 1, "slidesToScroll": 1, "speed": 800, "centerMode": false, "dots": true, "variableWidth": true, "autoplay": false, "autoplaySpeed": 2000, "infinite": true,
  };
  showNotes = false;
  LiveListingId = 0;
  loadPageContent() {

    this.loaderService.display(true);
    this.defaultDocAccessOutput();
    if (this.isUserLoggedIn == false) {
      if (this.user != "") {
        this.user.Id = 0;
      }
    }

    this._propertyManagerService.GetPropertyGuid(this.propertyGuid).subscribe(res => {
      if (res.toString().length > 0) {
        this.actualPropertyId = parseInt(res.toString().split('|')[1]);
      }
    });

    this._propertyService.getDataEntryPropertyDetails(this.propertyGuid, this.user.Id).subscribe(response => {
      if (response != null) {
        if (this.property.IsPortfolio || this.property.ParentPortfolioName != '') {
          this.BindColumns();
          if (this.dtElement) {
            this.dtElement.dtInstance.then(x => x.draw());
          }
          else {
            this.bindTable(this.propertyGuid);
          }
        }
     
        this.property = response;
        this.property.IsDEProperty = true;
        this.propertyGuid = response.Guid;
        this.isPropertyForSale = this.property.PropertyForId === 601;
        this.canEditHistory = (this.isUserLoggedIn && this.canEditProperty && this.canEditPropertyForBroker && (this.authService.IsUserRole(this.authService.UserRole.Admin) || this.authService.IsUserRole(this.authService.UserRole.SuperAdmin) || (this.authService.IsUserRole(this.authService.UserRole.DataEntryStaff) && this.isPropertyForSale == false)))
        this.propertyLatitude = response.Latitude != null ? parseFloat(response.Latitude) : 40.730610;
        this.propertyLongitude = response.Longitude != null ? parseFloat(response.Longitude) : -73.935242;
        this.docAccessOutput.PropertyId = this.property.Id;
        this.propertyId = this.property.Id;
        response.LeaseCommencementDate = this.Validation.convertUTCDateToLocalDate(response.LeaseCommencementDate);
        response.LeaseExpirationDate = this.Validation.convertUTCDateToLocalDate(response.LeaseExpirationDate);
        this.property.Remaining_Term = this.Validation.getRemainingTerm(response.LeaseExpirationDate, response.LeaseCommencementDate);

        if (this.property.PropertyCharacteristicsList.length > 0) {
          this.property.PropertyCharacteristicsList.forEach(item => {
            this.characterstics += item.Description + ", ";
          });
          this.characterstics = this.characterstics.slice(0, -2)
        }
        else {
          this.characterstics = '-'
        }
        if (this.property.PropertyCharacteristicsList.filter(x => x.Id == 2908).length > 0 || this.property.OnlyZCF) {
          this.capratetext = 'ZCF';
        }
        else {
          this.capratetext = 'Cap Rate';
        }

        if ((this.authService.IsUserRole(this.authService.UserRole.Principal1031) && this.property.PropertyForId == 602) || !this.isUserLoggedIn) {
          this.enableShare = false;
        }
        if (this.isUserLoggedIn) {
          if (this.authService.IsUserRole(this.authService.UserRole.Broker) || this.authService.IsUserRole(this.authService.UserRole.Admin) ||  this.authService.IsUserRole(this.authService.UserRole.SuperAdmin)) {
            this.showLikesAndViews = true;
          }

          if (this.authService.IsUserRole(this.authService.UserRole.Principal1031) && !this.isPropertyForSale) {
            this.showContactUs = false;
          }
          this.commonService.GetPropertyContactPersonList(this.property.Id).subscribe(resp => {
            if (resp.length != 0) {
              let isContactUserLoggerdin = resp.find(x => x.UserId == this.user.Id);
              if (isContactUserLoggerdin != undefined) {
                this.viewActivityLog = true;
                this.accessAdded = 1;
              }
            }
          });
        }

        let defaultImage = [];
        let images = this.property.Images;

        if (this.property.Images.length == 1) {
          this.only1PropImage = true;
          let duplicate = this.property.Images;
          this.property.Images.push(this.property.Images[0]);
        }

        if (this.staticTabs.tabs.length > 0) {
          if (images.length > 0 || (this.property.IsPortfolio && this.property.PortfolioPropertyIds.length == 0)) {
            this.staticTabs.tabs[0].active = true;
          }
          else {
            this.staticTabs.tabs[1].active = true;
            if (this.property.Latitude != "0" && this.property.Longitude != "0") {
              this.staticTabs.tabs[1].active = true;
            }
            else {
              this.showmap = false;
              this.staticTabs.tabs[0].active = true;
            }
          }
        }

        if ((this.property.Latitude == null && this.property.Longitude == null) || (this.property.Latitude == '0' && this.property.Longitude == '0')) {
          this.showmap = false;
          this.staticTabs.tabs[0].active = true;
        }

        if (this.property.VideoURL != null && this.property.VideoURL != '') {
          this.commonService.getIdFromUrl(this.property.VideoURL).subscribe(res => {
            this.videoUrlResponse = res;
            let actualVideoUrl = "https://player.vimeo.com/video/" + this.videoUrlResponse.video_id;
            this.videoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(actualVideoUrl);
          });
        }

        if (this.property.PropertyContactPersonsList != null) {

          for (let item of this.property.PropertyContactPersonsList) {
            if (item.ContactTypeId == ContactType.Others) {
              this.hasOtherContactType = true;
            }
            else {
              this.hasOtherContactType = false;
            }
          }

        }

        if (this.property.Latitude != "0" && this.property.Longitude != "0") {
          this.mapProp = {
            center: new google.maps.LatLng(this.propertyLatitude, this.propertyLongitude),
            draggableCursor: 'auto',
            zoom: 15,
            zoomControlOptions: {
              position: google.maps.ControlPosition.LEFT_CENTER,
            },
            streetViewControlOptions: {
              position: google.maps.ControlPosition.LEFT_CENTER,
            },
            mapTypeControl: false,
            mapTypeId: google.maps.MapTypeId.ROADMAP
          };

          this.setMap();
          setTimeout(() => { this.setCenter() }, 10);
        }
        else {
          this.showmap = false;
        }

        this.documentList();

        if (this.user != '' && this.user != null) {
          if (this.authService.IsUserRole(this.authService.UserRole.Principal) || this.authService.IsUserRole(this.authService.UserRole.Principal1031) || this.authService.IsUserRole(this.authService.UserRole.ExternalBroker)) {
            this.docAccessInput.PropertyId = this.property.Id;
            this.docAccessInput.UserId = this.user.Id;
            this.ndaDetails.Name = this.user.FirstName + " " + this.user.LastName;
            this.ndaDetails.Address = this.property.FullAddress;
            this._propertyService.getAccessRequestForDocuments(this.docAccessInput).subscribe(response => {
              if (response != null) {
                this.docAccessOutput = response;
              }
            });
          }
        }
        if (this.user.Role !== undefined) {
          if (this.authService.IsUserRole(this.authService.UserRole.Principal) || this.authService.IsUserRole(this.authService.UserRole.Principal1031)) {
            if (this.nextTabToShow === this.propertyTabs.SendInquiryPopup) {
              $("#btnSentInquiry").click();
            }
            else if ((this.nextTabToShow !== this.propertyTabs.PlaceOffer) || (this.property.PropertyStatus === 'Available' && this.property.OfferPlaced == 0 && this.nextTabToShow === this.propertyTabs.PlaceOffer)) {
              this.activeTab = this.nextTabToShow;
            }
          }
          else if (this.nextTabToShow !== this.propertyTabs.SendInquiryPopup && this.nextTabToShow !== this.propertyTabs.PlaceOffer) {
            this.activeTab = this.nextTabToShow;
          }
        }

        this.setActiveTab();
        this.loaderService.display(false);
      }
      else {
        if (this.authService.logoutClicked == false) {
          this.loaderService.display(false);
          this._toastService.clearAllToast();
          this._toastService.addToast({ title: 'Property Not Available', msg: "The property you are trying to view is not available", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
          this.router.navigate(['/home']);
        }
        else {
          this.authService.logoutClicked = false;
        }
      }
      this.LiveListingId = response.LiveListingId;
      if (!this.Validation.IsinValid(this.LiveListingId)) {
        this.showNotes = true;
      }


      if ((this.authService.IsUserRole(this.authService.UserRole.Admin) || this.authService.IsUserRole(this.authService.UserRole.SuperAdmin)) && this.Validation.IsinValid(this.routeName)) {
        this.prevPage = 'Pending Approval';
        this.prevPageRouteLink = 'pending-approval-list';
      }
      else if ((this.authService.IsUserRole(this.authService.UserRole.Admin) || this.authService.IsUserRole(this.authService.UserRole.SuperAdmin)) && this.Validation.IsValid(this.routeName) && this.routeName == "Activity Log") {
        this.prevPage = this.routeName;
        this.prevPageRouteLink = this.routeLink;
      }
      else {
        this.prevPage = 'Property List';
        this.prevPageRouteLink = 'property-listing';
      }

    });
  }
  actualPropertyId = 0;
  setActiveTab() {
    if (this.tabToShow != null) {
      if (this.tabToShow === "inquiry") {
        this.activeTab = PropertyTabs.Inquiries;
      }
      else if (this.tabToShow === "Offer") {
        this.activeTab = PropertyTabs.Offer;
      }
      else if (this.tabToShow === "Memorandom") {
        this.activeTab = PropertyTabs.Memorandom;
      }
      else if (this.tabToShow === "analytics") {
        this.activeTab = PropertyTabs.Analytics;
      }
      else {
        this.activeTab = PropertyTabs.Home;
      }
    }
  }

  showOffer(status: boolean) {
    if (status) {
      this.showPlaceOffer = true;
      this.placeOfferVisibility = true;
      this.openPlaceOfferTab(this.propertyTabs.PlaceOffer);
    }
    else {
      this.showPlaceOffer = false;
      this.placeOfferVisibility = false;
    }
  }
  setCenter() {
    let bounds = new google.maps.LatLngBounds();
    if (this.property.IsPortfolio) {
      this.property.PortfolioProperties.forEach(item => {
        let location = new google.maps.LatLng(parseFloat(item.Latitude), parseFloat(item.Longitude));
        let marker = new google.maps.Marker({
          position: location,
          map: this.map,
          title: item.PropertyName + ", " + item.Address
        });

        let loc = new google.maps.LatLng(parseFloat(item.Latitude), parseFloat(item.Longitude));
        bounds.extend(loc);
      })
      this.map.fitBounds(bounds);

      setTimeout(() => { google.maps.event.trigger(this.map, "resize"); }, 5)

    }
    else {
      this.map.setCenter(new google.maps.LatLng(this.propertyLatitude, this.propertyLongitude));
      let location = new google.maps.LatLng(this.propertyLatitude, this.propertyLongitude);
      let marker = new google.maps.Marker({
        position: location,
        map: this.map,
        title: this.property.Address
      });
    }
  }

  onToggleDescriptionVisibility() {
    if (this.isDescriptionVisible) {
      this.toggleDetailsText = '-Show Details';
      this.isDescriptionVisible = false;
    }
    else {
      this.toggleDetailsText = '-Hide Details';
      this.isDescriptionVisible = true;
    }
  }

  onTabClick(tab: number) {
    if (!this.isUserLoggedIn) {
      //if (tab == PropertyTabs.Memorandom)
      //    this._toastService.addToast({ title: 'Unauthorized Action', msg: "Please Login to view offering memorandum", timeout: 2000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
      //else if (tab == PropertyTabs.Diligence)
      //    this._toastService.addToast({ title: 'Unauthorized Action', msg: "Please Login to view due diligence", timeout: 2000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
      //else if (tab == PropertyTabs.Offer)
      //    this._toastService.addToast({ title: 'Unauthorized Action', msg: "Please Login to view placed offers", timeout: 2000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
      //else if (tab == PropertyTabs.Inquiries)
      //    this._toastService.addToast({ title: 'Unauthorized Action', msg: "Please Login to view placed offers", timeout: 2000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
      this.nextTabToShow = tab;
      document.getElementById("openModalButton").click();
    }
    else {
      this.activeTab = tab;
      if (tab == 9) {
        this.unreadMessageCount = 0;
      }
    }
  }

  openPlaceOfferTab(tab: number) {
    this.authService.isLoggedIn.subscribe(i => { this.isUserLoggedIn = i });
    this.placeOfferInputModel.PropertyId = this.property.Id;
    if (this.isUserLoggedIn) {
      if ((this.authService.IsUserRole(this.authService.UserRole.Principal) || this.authService.IsUserRole(this.authService.UserRole.Principal1031)) || this.authService.IsUserRole(this.authService.UserRole.Broker) || this.authService.IsUserRole(this.authService.UserRole.ExternalBroker)) {

        this.activeTab = tab;
      }
      else {
        this._toastService.addToast({ title: 'Unauthorized Action', msg: "Please Login as a principal or broker user to place an offer", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
      }
    }
    else {
      //this._toastService.addToast({ title: 'Unauthorized Action', msg: "Please Login to place an offer", timeout: 2000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
      this.nextTabToShow = tab;
      document.getElementById("openModalButton").click();
    }
  }

  onVideoTabClick(template: TemplateRef<any>, classes: any) {
    this.modalRef = this.modalService.show(template, { class: classes });
  }

  onBannerTabClick(tab: number) {

    //this.activeBannerTab = (tab == 3 ? 2 : tab);
    if (tab == 3) {
      setTimeout(() => this.setMap(tab == 3), 100)
    }
    if (tab == 2) {
      setTimeout(() => this.setMap(), 100);
    }
  }

  onSimilarPropertiesClick() {

    this._propertyService.fromHome = true;
    this._propertyService.criteria = this.searchCriteria;
    this.router.navigate(['/propertylisting']);
  }

  defaultSearchCriteriaValues() {
    this.searchCriteria.SkipCount = 0;
    this.searchCriteria.TakeCount = 20;
    this.searchCriteria.Address = '';
    this.searchCriteria.AssetTypes = [];
    this.searchCriteria.PriceFrom = null;
    this.searchCriteria.PriceTo = null;
    this.searchCriteria.Tenants = [];
    this.searchCriteria.Ratings = [];
    this.searchCriteria.Terms = [];
    this.searchCriteria.SortValue = "PLH";
  }

  onViewPropertyEvent(guid: string) {
    this.propertyGuid = guid;
    this.ngOnInit();
  }

  public getOfferPlaced(offerPlaced: any): void {


    this.property.OfferPlaced = offerPlaced;
  }

  public getInquiryPlaced(inquiryPlaced: any): void {


    this.property.InquiryPlaced = inquiryPlaced;
  }



  openInquiryModal(template: TemplateRef<any>, classes: any) {
    this.authService.isLoggedIn.subscribe(i => { this.isUserLoggedIn = i });
    this.placeOfferInputModel.PropertyId = this.property.Id;

    if (this.isUserLoggedIn) {
      if (this.authService.IsUserRole(this.authService.UserRole.Principal) || this.authService.IsUserRole(this.authService.UserRole.Principal1031) || this.authService.IsUserRole(this.authService.UserRole.ExternalBroker)) {
        if (this.property.InquiryPlaced == 0) {
          this.showFileUpload = false;
          this.modalRef = this.modalService.show(template, { class: classes });
        }
        else {
          this._toastService.addToast({ title: 'Unable to Complete the Action', msg: "You have already submitted inquiry for this property", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
        }
      }
      else {
        this._toastService.addToast({ title: 'Unauthorized Action', msg: "Please Login as a principal user to submit an inquiry", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })

      }
    }
    else {
      //this._toastService.addToast({ title: 'Unauthorized Action', msg: "Please Login to send an Inquiry.", timeout: 2000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
      this.nextTabToShow = this.propertyTabs.SendInquiryPopup;
      document.getElementById("openModalButton").click();
    }
  }

  openLoginModal(template: TemplateRef<any>, classes: any, guid) {
    if (this.authService.isAuth0Enabled) {
      this._auth0.login();
    }
    else {
      this.modalRef = this.modalService.show(template, { class: classes });
    }
  };


  onEditPropertyClick() {
    this.router.navigate(['/dataentry-property/' + this.property.Guid], { queryParams: { isPortfolio: this.property.IsPortfolio } });
  }

  documentList() {
    if (this.property.Documents != null && this.property.Documents.length > 0) {
      let docsOfferingMemorandom = this.property.Documents.filter(i => i.CategoryId === DocumentType.OfferingMemorandom);
      let docsDueDiligence = this.property.Documents.filter(i => i.CategoryId != DocumentType.OfferingMemorandom);

      this.offeringMemorandomDocList = docsOfferingMemorandom;
      this.dueDiligenceDocList = docsDueDiligence;
    }
  }

  onDueDiligenceProceedClick() {
    this.loaderService.display(true);
    this.docAccessOutput.RequestForDueDiligenceAccessId = this.property.DueDiligenceReqApproval ? DocAccessStatus.Pending : DocAccessStatus.New;
    this.docAccessOutput.IsPrincipal = true;
    this.docAccessOutput.DocumentType = DocumentType.DueDiligenceDocAccess;
    var userId = this.user.Id;
    this.docAccessOutput.LoggedinUserId = userId
    this._propertyService.saveAccessRequestForDocuments(this.docAccessOutput).subscribe(response => {
      if (response != null) {
        if (this.docAccessOutput.RequestForDueDiligenceAccessId == DocAccessStatus.Pending) {
          this._toastService.addToast({ title: 'Success', msg: "You can download the due diligence documents after admin approval", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
        }
        else {
          this._toastService.addToast({ title: 'Success', msg: "You can download the due diligence documents", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
        }
      }
      this.loaderService.display(false);
    });
  }

  onMemorandomProceedClick() {
    this.loaderService.display(true);
    this.docAccessOutput.RequestForOfferAccessId = this.property.OfferMemoReqApproval ? DocAccessStatus.Pending : DocAccessStatus.New;
    this.docAccessOutput.IsPrincipal = true;
    this.docAccessOutput.DocumentType = DocumentType.OfferDocAccess;
    this.user = this.authService.user;
    var userId = this.user.Id;
    this.docAccessOutput.LoggedinUserId = userId;
    this._propertyService.saveAccessRequestForDocuments(this.docAccessOutput).subscribe(response => {
      if (response != null) {
        if (this.docAccessOutput.RequestForOfferAccessId == DocAccessStatus.Pending) {
          this._toastService.addToast({ title: 'Success', msg: "You can download the offering memorandom document after admin approval", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
        }
        else {
          this._toastService.addToast({ title: 'Success', msg: "You can now download the offering memorandom document", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
        }
      }
      this.loaderService.display(false);
    });
  }

  defaultDocAccessOutput() {
    this.docAccessOutput.PropertyId = this.property.Id;
    this.docAccessOutput.UserId = this.user.Id;
    this.docAccessOutput.RequestForOfferAccessId = DocAccessStatus.New;
    this.docAccessOutput.RequestForDueDiligenceAccessId = DocAccessStatus.New;
    this.docAccessOutput.IsPrincipal = false;
  }

  GetMessageUnreadMessageCount() {
    this.messageInput.CreatedById = this.user.Id;
    this.messageInput.ObjectId = this.property.Id
    this.messageInput.ObjectTypeId = 302;
    this.commonService.GetMessageUnreadMessageCount(this.messageInput).subscribe(responds => {
      this.unreadMessageCount = responds;
    });
  }
  afterChange(e) {

  }

  openPropertyShareModal(template: TemplateRef<any>, classes: any, tab) {
    if (!this.isUserLoggedIn) {
      //if (tab == PropertyTabs.Memorandom)
      //    this._toastService.addToast({ title: 'Unauthorized Action', msg: "Please Login to view offering memorandum", timeout: 2000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
      //else if (tab == PropertyTabs.Diligence)
      //    this._toastService.addToast({ title: 'Unauthorized Action', msg: "Please Login to view due diligence", timeout: 2000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
      //else if (tab == PropertyTabs.Offer)
      //    this._toastService.addToast({ title: 'Unauthorized Action', msg: "Please Login to view placed offers", timeout: 2000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
      //else if (tab == PropertyTabs.Inquiries)
      //    this._toastService.addToast({ title: 'Unauthorized Action', msg: "Please Login to view placed offers", timeout: 2000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
      this.nextTabToShow = this.propertyTabs.Home;
      document.getElementById("openModalButton").click();
    }
    else {
      this.modalRef = this.modalService.show(template, { class: classes });
    }
  }

  shareOnSocialMedia(media: number) {
    let generateRandomNumber = Math.floor(100000 + Math.random() * 900000);
    this.currentUrl = environment.share_url + "/share/property/" + this.propertyGuid + "?key=" + generateRandomNumber.toString();

    if (media == SocialMedia.Twitter) {
      window.open('https://twitter.com/intent/tweet?url=' + this.currentUrl, '_blank');
    }
    else if (media == SocialMedia.FB) {
      window.open('https://www.facebook.com/sharer/sharer.php?u=' + this.currentUrl, '_blank');
    }
    else if (media == SocialMedia.LinkedIn) {
      window.open('https://www.linkedin.com/sharing/share-offsite/?url=' + this.currentUrl, '_blank');
    }
  }

  //add to favorites section - start
  showAddToFav = false;
  addToFavorites = {} as IAddToFavorites;
  classToBind = 'fav';
  toolTipFav = "Add to favorites";
  addToFav(propertyId: any) {
    this.authService.isLoggedIn.subscribe(i => { this.isUserLoggedIn = i });
    this.user = this.authService.user;
    if (this.isUserLoggedIn) { //if user is logged in
      if (this.authService.IsUserRole(this.authService.UserRole.Principal) || this.authService.IsUserRole(this.authService.UserRole.Principal1031) || this.authService.IsUserRole(this.authService.UserRole.ExternalBroker)) { // if logged in user is principal or 1031 principal
        this.addToFavorites.UserId = this.user.Id;
        this.addToFavorites.PropertyId = propertyId;

        // call addToFavorite service
        this._propertyManagerService.addToFavorite(this.addToFavorites).subscribe(response => {

          if (response == "1") { // added
            this.property.IsFav = true;
            this.classToBind = 'favClicked';
            this.toolTipFav = "Remove from favorites";
            this._toastService.addToast({
              title: 'Message', msg: 'This property has been added to your favorites.', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success'
            })
          }
          else { // removed
            this.property.IsFav = false;
            this.classToBind = 'fav';
            this.toolTipFav = "Add to favorites";
            this._toastService.addToast({
              title: 'Message', msg: 'This property has been removed from your favorites.', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success'
            })
          }
          this.onSetActions();
        });
      }
      else {
        this._toastService.addToast({ title: 'Unauthorized Action', msg: "Please Login as a principal to mark as favorite.", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
      }
    }
    else {
      this._toastService.addToast({ title: 'Unauthorized Action', msg: "Please Login to mark as favorite.", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
    }
  }
  onSetActions() {
    if (this.property.IsFav == true) {
      this.classToBind = 'favClicked';
      this.toolTipFav = "Remove from favorites";
    }
    else {
      if (this.property.PropertyForId === 601) {
        this.classToBind = 'fav';
      }
      else {
        this.classToBind = 'favClicked55';
      }
    }
  }

  // add to favorites section - end

  modalRefDuplicate: BsModalRef;
  selectedPropertyIdForDuplicates = 0;
  openModalForDuplicates(template: TemplateRef<any>, classes: any, id) {
    this.selectedPropertyIdForDuplicates = id;
    this.modalRefDuplicate = this.modalService.show(template, { class: classes });
  }

  hideColumn(col: number) {
    if (this.selectedColumns.indexOf(col) > -1) {
      return false; // show
    }
    else {
      return true; // hide
    }
  }

  searchCriteriaForExport = {} as IPropertySearchCriteria;
  exportToExcel() {
    this.TableColumns = [
      { data: 'Id' },
      { data: 'TenantName' },
      { data: 'OM' },
      { data: 'State' },
      { data: 'City' },
      //{ data: 'PropertyType' },
      { data: 'PropertyStatus' },
      { data: 'Price' },
      { data: 'RentNOI' },
      { data: 'Rank' }]
    this.loaderService.display(true);
    this.searchCriteriaForExport = this.searchCriteria;
    this.searchCriteriaForExport.IsExport = true;
    var loggedinUserId = this.user.Id;
    const inputModel =
    {
      Extra_param: this.searchCriteria
    }

    let dataTablesParameters = inputModel;

    dataTablesParameters.Extra_param = this.searchCriteriaForExport;
    dataTablesParameters.Extra_param.IsArchive = false;
    dataTablesParameters.Extra_param.IsComp = true;
    this.http.post<string>(this.BASE_URL + '/dataentryproperty/dataentryportfolioProperties/' + this.propertyGuid + '/' + this.loggedInUserId, dataTablesParameters).subscribe(resp => {
      let filenameWithExtension: string = resp.toString();
      let filenameWithoutExtension = filenameWithExtension.toString().split('.')[0];
      this.Validation.downloadExcelFile('/upload/excelfile/' + filenameWithoutExtension, 'Portfolio Properties.xlsx');
      this.loaderService.display(false);
    });
  }


  tableColumns: collapseColumns[] = [];
  BindColumns() {
    this.tableColumns = [
      { id: 1, name: 'OM' },
      { id: 2, name: 'State' },
      { id: 3, name: 'City' },
      //{ id: 4, name: 'Property Type' },
      { id: 5, name: 'Status' },
      { id: 6, name: 'Price' },
      { id: 7, name: 'RentNOI' },
      { id: 8, name: 'CapRate' },
      { id: 9, name: 'RemainingTerm' }
    ]
    this.selectedColumns = [];
    if (localStorage.getItem("portfolio_property_listings_selectedColumns_LS") !== null) {
      this.selectedColumns = JSON.parse(localStorage.getItem("portfolio_property_listings_selectedColumns_LS"));
    }
    else {
      this.tableColumns.forEach(item => {
        this.selectedColumns.push(item.id);
      });
    }
    this.onRedirection();
  }


  onRedirection() {
    localStorage.setItem("portfolio_property_listings_selectedColumns_LS", JSON.stringify(this.selectedColumns));
  }

  IsLoadDES = false;
  bindTable(propertyGuid) {

    this.TableColumns = [
      { data: 'Id' },
      { data: 'TenantName' },
      { data: 'OM', orderable: false },
      { data: 'State' },
      { data: 'City' },
      //{ data: 'PropertyType' },
      { data: 'PropertyStatus' },
      { data: 'Price' },
      { data: 'RentNOI' },
      { data: 'CapRate' },
      { data: 'RemainingTerm' },
      { data: 'Rank' }]

    //{ data: 'CapRate' },
    //{ data: 'RemainingTerm' },
    //{ data: 'BuildingSize' },
    //{ data: 'LeaseStructure' }

    this.loaderService.display(true);
    const that = this;
    this.dtOptions = {
      pagingType: 'full_numbers',
      "pageLength": 50,
      serverSide: true,
      processing: true,
      info: false,
      language: {
        zeroRecords: null,
        processing: `<div class="custom-dt-loader">
        <div class="circle-loader-wrapper">
          <div class="circle-loader-ring"></div>
          <img src="assets/img/logos/logo.png" class="loader-icon" />
        </div>
      </div>
     `,
      },
      bLengthChange: false,
      initComplete: () => $('.dataTables_filter').css('display', 'none'),
      ajax: (dataTablesParameters: any, callback: Function) => {
        this.IsLoadDES = true;
        that.http.post<DataTablesResponse>(
          this.BASE_URL + '/dataentryproperty/dataentryportfolioProperties/' + that.propertyGuid + '/' + this.loggedInUserId, dataTablesParameters).subscribe(resp => {
            this.portfolioProperties = resp.data ? resp.data : [];
            if (resp) {
              callback({
                recordsTotal: resp.recordsTotal,
                recordsFiltered: resp.recordsFiltered,
                data: []
              });
              if (resp.data.length === 0) {
                $(".dataTables_paginate.paging_full_numbers").hide();
              }
              else {
                $(".dataTables_paginate.paging_full_numbers").show();
              }
              $(".paginate_button.first,.paginate_button.last").hide();
            } else {
              callback({
                recordsTotal: 0,
                recordsFiltered: 0,
                data: []
              });
              $(".dataTables_paginate.paging_full_numbers").hide();
            }
            this.IsLoadDES = false;
          });
        this.loaderService.display(false);
      },
      columns: that.TableColumns
    };
  }

  search = "";
  onViewProperty(Guid) {
    this.onRedirection();
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      this.search = params['search'];
    });
    if (!this.Validation.IsinValid(this.search)) {
      this.router.navigateByUrl('viewdeproperty/' + Guid + '?prevroute=Saved Search&link=' + encodeURIComponent(this.router.url));
    }
    else {
      this.router.navigateByUrl('viewdeproperty/' + Guid + '?prevroute=Property List&link=' + encodeURIComponent(this.router.url));
    }
  }

  previews(template: TemplateRef<any>, classes, document) {
    this.docPreview = document;
    this.documentPreview = this.modalService.show(template, { class: classes });
  }
}
